<div class="user-container" (click)="showUserProfile()">
    <div class="user-inner">
        <user-avatar [uploadAvatar]="false" [user]="currentUser" [title]="currentUser?.name" width="30px" height="30px">
        </user-avatar>
        <div fxLayout="column">
            <span class="label">
                {{'sidebar.user.logged_in_as'|translate}}
            </span>
            <h3>{{currentUser?.name}}{{ (sipNumber && ' - ' + sipNumber) || '' }}</h3>
        </div>
    </div>
</div>
<app-menu></app-menu>
